import React, { Component } from 'react'
import { TextField, Button, Typography } from '@mui/material'
import { withRouter } from 'react-router';
import buildingSVG from '../../assets/images/buildingSVG.png'
import './map.styles.css'

class Map extends Component {
    constructor(props) {
        super(props)

        this.props = props
        this.map = null;

        this.state = {
            selectedLocation: {
                latitude: 33.746150401181836,
                longitude: -117.76343162153378
            },
            name: "North Tustin",
            windSpeed: 0.89,
            gust: 1.34,
            temp: 21.73,
            pressure: 1014,
            humidity: 31
        }

        console.log("Map props : ", props)
    }

    updateSelectedLocation = (evt) => {
        console.log("evt : ", evt)
        let LocationInPixel = new window.Microsoft.Maps.Point(evt.getX(), evt.getY());
        let mapLocation = this.map.tryPixelToLocation(LocationInPixel);
        console.log("selectedLocation : ", mapLocation)

        this.setState({
            selectedLocation: mapLocation
        })

        this.getWheatherInfo(mapLocation);
    }

    updateWheatherState = (wheatherInfo) => {
        this.setState({
            name: (wheatherInfo.name ? wheatherInfo.name : "--"),
            windSpeed: (wheatherInfo.wind.speed ? wheatherInfo.wind.speed : "--"),
            gust: (wheatherInfo.wind.gust ? wheatherInfo.wind.gust : "--"),
            temp: (wheatherInfo.main.temp ? wheatherInfo.main.temp - 273 : "--").toFixed(1),
            pressure: (wheatherInfo.main.pressure ? wheatherInfo.main.pressure : "--"),
            humidity: (wheatherInfo.main.humidity ? wheatherInfo.main.humidity : "--")
        })
    }

    getWheatherInfo = (newLocation) => {
        const requestOptions = {
            method: 'GET'
        };
        fetch("http://api.openweathermap.org/data/2.5/weather?lat=" + newLocation.latitude + "&lon=" + newLocation.longitude + "&appid=bde61631584bfd88af405e8bc74badf1",
            requestOptions)
            .then(async (response) => {
                console.log("response : ", response)
                try {
                    const data = await response.json()
                    console.log('response data : ', data)

                    this.updateWheatherState(data)
                } catch (error) {
                    console.log('Error happened here!')
                    console.error(error)
                }
                // console.log("response.json() : ", response)
            })
        // .then((resp) => {
        //     console.log("wheatherRequest resp : ", resp)
        // })
    }

    goToLocation = (evt) => {
        let latitude = document.getElementById("latitude").value
        let longitude = document.getElementById("longitude").value

        if (latitude && longitude) {
            console.log("latitude : ", latitude)
            console.log("longitude : ", longitude)

            let newLocation = new window.Microsoft.Maps.Location(latitude, longitude)
            this.map.setView({
                center: newLocation,
                zoom: 19
            });

            this.createScaledPushpin(newLocation)
            this.getWheatherInfo(newLocation);
        }
    }

    goToViewer = (evt) => {
        let { history } = this.props
        history.push("/viewer")
    }

    createScaledPushpin(location) {
        var pin = new window.Microsoft.Maps.Pushpin(location, {
            //Generate a base64 image URL from the canvas.
            icon: buildingSVG,
            //Anchor based on the center of the image.
        })

        //Add the pushpin to the map
        this.map.entities.push(pin);

        window.Microsoft.Maps.Events.addHandler(pin, 'click', () => {
            this.goToViewer()
        });
    }

    componentDidMount() {
        let interval = setInterval(() => {
            if (window.Microsoft) {
                if (window.Microsoft.Maps) {
                    let { selectedLocation } = this.state;
                    let startLocation = new window.Microsoft.Maps.Location(selectedLocation.latitude, selectedLocation.longitude)
                    console.log("component did mount!", window.Microsoft)
                    this.map = new window.Microsoft.Maps.Map('#myMap', {
                        center: startLocation,
                        mapTypeId: window.Microsoft.Maps.MapTypeId.aerial,
                        zoom: 19
                    });

                    window.Microsoft.Maps.Events.addHandler(this.map, 'click', this.updateSelectedLocation);

                    document.getElementById("coordControl").style.display = "block"
                    clearInterval(interval)
                }
            }
        }, 1000)
    }

    render() {
        let { selectedLocation, name, temp, pressure, humidity, windSpeed, gust } = this.state;

        return (
            <div className="mapRoot">
                <div id="coordControl" className="coordControlRoot" >
                    <div>
                        <Typography variant="h6" gutterBottom component="div">
                            Selected Location
                        </Typography>
                    </div>

                    <div>
                        <TextField id="latitude" label="Latitude" variant="standard" value={selectedLocation.latitude} />
                        <TextField id="longitude" label="Longitude" variant="standard" value={selectedLocation.longitude} />
                    </div>

                    <div>
                        <br />
                        <Button onClick={this.goToLocation} variant="contained">Go To Location</Button>
                    </div>

                    <div>
                        <br />
                        <Typography variant="h6" gutterBottom component="div">
                            Weather Information
                        </Typography>
                    </div>

                    <div id="wheatherInfo" >
                        <b>Name:</b> {name}
                    </div>

                    <div id="wheatherInfo" >
                        <b>Tempreture:</b> {temp}
                    </div>

                    <div id="wheatherInfo" >
                        <b>Pressure:</b> {pressure}
                    </div>

                    <div id="wheatherInfo" >
                        <b>Humidity:</b> {humidity}
                    </div>

                    <div id="wheatherInfo" >
                        <b>Wind Speed:</b> {windSpeed}
                    </div>

                    <div id="wheatherInfo" >
                        <b>Gust:</b> {gust}
                    </div>

                    <div>
                        <br />
                        {/* <Button onClick={this.goToViewer} variant="contained">Start Game</Button> */}
                        <Typography variant="button" display="block" gutterBottom>
                            <b>Click on the building appeared on selected location to start the game.</b>
                        </Typography>
                    </div>
                </div>

                <div id="myMap">
                </div>
            </div>
        )
    }
}

export default withRouter(Map);